import * as Bixby from '$/core';

export abstract class NewsClientService {
  private static baseUrl: string = Bixby.Constants.API_NEWSCONTROLLER;

  public static async getNews(): Promise<Bixby.Models.ClientNews[]> {
    const url = `${NewsClientService.baseUrl}/${Bixby.Constants.API_ACTION_SEARCH}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.get(route);
  }

  public static async getNewsBlob(
    companyId: string,
    timeframe: 'All' | 'LastXDays',
    newsTypeIds: string[],
    timezone: string
  ): Promise<Blob> {
    const baseUrl = `${NewsClientService.baseUrl}/${Bixby.Constants.API_ACTION_DOWNLOAD}`;
    const map: any = {};
    map[Bixby.Constants.API_PARAMS_COMPANYID] = companyId;
    map[Bixby.Constants.API_PARAMS_NEWSTIMEFRAME] = timeframe;
    map[Bixby.Constants.API_PARAMS_NEWSTYPEID] = newsTypeIds;
    map[Bixby.Constants.API_PARAMS_TIMEZONE] = timezone;
    const url = `${baseUrl}${Bixby.Utils.objectToQueryString(map)}`;
    const route = Bixby.API.ServerRoute.forAction(url);
    return await Bixby.API.getFile(route);
  }

  public static async getNewsByCompanyId(companyId: string): Promise<Bixby.Models.ClientNews[]> {
    const url = `${NewsClientService.baseUrl}/${Bixby.Constants.API_ACTION_SEARCH}`;
    const qs = Bixby.Utils.objectToQueryString({ companyId });
    const route = Bixby.API.ServerRoute.forAction(`${url}${qs}`);
    return await Bixby.API.get(route);
  }

  public static async getById(id: string): Promise<Bixby.Models.ClientNews> {
    const route = Bixby.API.ServerRoute.forAction(`${NewsClientService.baseUrl}/${id}`);
    return await Bixby.API.get(route);
  }
}
